<template>
  <li v-bind:class="status">
      <div class="step">
          <i :class="icon"></i>
          <!-- <router-link :to="link"></router-link> -->
        </div>
        <div class="caption">{{caption}}</div>
      </li>
</template>

<script>
  export default {
    name: 'Step',
    props: ["caption", "link", "icon", "rank"],
    computed: {

      status: function(){
        var $current_step  = this.$route.meta.rank

        switch (true) {
          case this.rank == $current_step:
            return "active"
          case this.rank > $current_step:
            return "complete"
          default:
            return "yo"
        }

      }
    }
  }
</script>

<style scoped>

</style>